import React from 'react';
import ReactDOM from 'react-dom/client';
import 'react-app-polyfill/ie11';
import 'react-app-polyfill/stable';
// import './index.css';
import App from 'app';
// Use consistent styling
import 'sanitize.css/sanitize.css';
import reportWebVitals from './reportWebVitals';
import { RecoilRoot } from 'recoil';
import { HelmetProvider } from 'react-helmet-async';
import { SnackbarProvider } from 'notistack';
import { DialogProvider } from 'muibox';
import { initSentry, ErrorBoundary } from './sentry';
import { PersistQueryClientProvider } from '@tanstack/react-query-persist-client';
import { queryClient, persister, PERSIST_MAX_AGE_MS } from 'app/queryClient';

// Initialize Sentry
initSentry();

const root = ReactDOM.createRoot(document.getElementById('root') as HTMLElement);
root.render(
  <React.StrictMode>
    <ErrorBoundary
      fallback={({ error, componentStack, resetError }) => (
        <div className="error-boundary">
          <h2>Something went wrong!</h2>
          <button onClick={resetError}>Try again</button>
          {process.env.NODE_ENV === 'development' && (
            <div>
              <p>{error.toString()}</p>
              <p>Component Stack: {componentStack}</p>
            </div>
          )}
        </div>
      )}
    >
      {/* PersistQueryClientProvider rehydrates the React Query cache from
          localStorage on boot (instant render of last-known-good data for
          agents/suppliers reopening the app on flaky networks). Sits ABOVE
          RecoilRoot so the cache is ready before any Recoil effect runs. */}
      <PersistQueryClientProvider
        client={queryClient}
        persistOptions={{ persister, maxAge: PERSIST_MAX_AGE_MS }}
      >
        <RecoilRoot>
          <HelmetProvider>
            <SnackbarProvider maxSnack={3}>
              <DialogProvider>
                <App />
              </DialogProvider>
            </SnackbarProvider>
          </HelmetProvider>
        </RecoilRoot>
      </PersistQueryClientProvider>
    </ErrorBoundary>
  </React.StrictMode>,
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
